export function Footer() {
  return (
    <footer className="w-full bg-yellow-500 text-gray-800 py-4">
      <div className="container mx-auto text-center">
        <p>&copy; {new Date().getFullYear()} Big Horn Olive Oil Company. All rights reserved.</p>
      </div>
    </footer>
  );
}
